import * as React from 'react';
import {Typography, WithStyles, withStyles,} from '@material-ui/core';
import {IEcoAgreement, IRespondEcoAgreement, IRespondEcoAgreementUpdate} from "@app-types/websocket/economy.types";
import {IFamilyMember} from "@app-types/websocket/family.types";
import TranslateNew from "@translate/TranslateNew";
import AgreementCard from "@components/economy/AgreementCard";
import { ecoContainerStyle } from './Container.style';

const tn = TranslateNew.getInstance();

interface IReceivedAgreementsCardProps extends WithStyles<typeof ecoContainerStyle>
{
    agreements: IEcoAgreement[];
    family: IFamilyMember[];
    userId:number;
    currency:string;
    respond: (response:IRespondEcoAgreement) => void;
    respondChange: (response: IRespondEcoAgreementUpdate) => void;
    edit: (agreement:IEcoAgreement) => void;
    seen: (agreementId:number) => void;
    scrollTime:number;
    waitForAgreementChat:(id:number) => void;
}

class ContainerReceivedAgreements extends React.Component<IReceivedAgreementsCardProps> {
    public render()
    {
        const { classes, agreements, family, respond,respondChange,waitForAgreementChat } = this.props;

        return (
            <div className={classes.container}>
                <div className={classes.titleWrapper}>
                    <Typography className={classes.heading1} gutterBottom={false}>{tn.lang.purchaseProposalReceived}</Typography>
                </div>
                {agreements.map((agreement) => (
                    <AgreementCard key={agreement.id} agreement={agreement} edit={() => this.props.edit(agreement)} currency={this.props.currency}
                        type="received" family={family} respond={respond} respondChange={respondChange} userId={this.props.userId} 
                        seen={this.props.seen} scrollTime={this.props.scrollTime} waitForAgreementChat={waitForAgreementChat}/>
                ))}
            </div>
        );
    }
}

export default withStyles(ecoContainerStyle)(ContainerReceivedAgreements);



// WEBPACK FOOTER //
// ./src/components/economy/ContainerReceivedAgreements.tsx